import { getAuth } from "firebase/auth";

const { REACT_APP_SERVER_URL } = process.env;

export const baseURL = `${REACT_APP_SERVER_URL}/api/v1`;

export const getIdToken = async () => await getAuth().currentUser.getIdToken();
